export default __webpack_public_path__ + "static/media/phone.2f909926.svg";